export default __webpack_public_path__ + "static/media/2007.78944346.png";